import { useQuery } from '@apollo/client/react';
import { assertIsDefinedOrThrow } from 'app-shared/utils';

import { GetCurrentSessionDocument } from '~/generated/graphql';

// Reads the session SessionGate already loaded, from the cache only: no
// request, and every screen below the gate can count on it being there.
// Saved changes (a new name) reach every reader through the cache.
export const useCurrentSessionOrThrow = () => {
  const { data } = useQuery(GetCurrentSessionDocument, {
    fetchPolicy: 'cache-only',
  });

  assertIsDefinedOrThrow(
    data,
    new Error('No session loaded: render this component below SessionGate.'),
  );

  return data;
};
